<template>
    <b-modal v-model="ShowModal" id="modal-center" class="modal-validation" size="md" no-close-on-backdrop="true"
        no-close-on-esc="true" centered hide-header hide-footer>
        <template v-slot:default>
            <p>
                Payment via Merchantrade Money is only available for transaction below RM10,000.00
            </p>
            <p>
                If you would like to perform a transaction above RM10,000.00 please proceed to use the "Remit"
                feature in Merchantrade Money mobile application.
            </p>
            <br />
            <div class="modal-button-wrapper">
                <b-button block variant="danger" @click="handleOk">OK</b-button>
            </div>
        </template>
    </b-modal>
</template>
<script>
    import CommonService from "../services/common";
    export default {
        name: "Diable10KMMPDialog",
        props: ["ShowModal"],
        methods: {
            handleOk: function (evt) {
                this.ShowModal = false;
                this.$emit('okclicked', this.ShowModal);
                evt.preventDefault();
            }
        }
    };
</script>